import { render, staticRenderFns } from "./InventoryDetail.vue?vue&type=template&id=41de3ea0&scoped=true"
import script from "./InventoryDetail.vue?vue&type=script&lang=js"
export * from "./InventoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de3ea0",
  null
  
)

export default component.exports